import React from 'react'; 
import PropTypes from 'prop-types';
import TextBox from '../Basic/TextBox';

export default class BusinessInfo extends React.Component {
    render() {
        const p = this.props;
        return (
            <div className="row">
                <div className="col-sm-8">
                    <TextBox title="Company name" id={p.name + "_businessName"} name={p.name + "_businessName"}
                        required disabled={p.disabled} maxLength={40}/>
                    <br />
                </div>
            </div>
        );
    }
}

BusinessInfo.propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool
};

export function BusinessInfoValidator(name) {
    return [
        [name + "_businessName", p => (p[name + "_businessName"]),"Company name"]];
}
